(function () {
  if (window.__poeticVariantSelectedLabel) return;
  window.__poeticVariantSelectedLabel = true;

  // Write the currently-selected value into each option group's label chip.
  function updateLabels(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.product-form__input').forEach(function (group) {
      var valueEl = group.querySelector('[data-selected-value]');
      if (!valueEl) return;

      // Radios / buttons / swatches: the checked input carries the value.
      var checked = group.querySelector('input[type="radio"]:checked');
      if (checked) {
        valueEl.textContent = checked.value;
        return;
      }

      // Dropdown: the chosen value lives on the .variant-selector <details>.
      var selector = group.querySelector('.variant-selector');
      if (selector) {
        valueEl.textContent = selector.getAttribute('data-value') || '';
      }
    });
  }

  function rootFrom(el, selector) {
    return el && el.closest ? el.closest(selector) : null;
  }

  // Radios/buttons/swatches fire a bubbling change event.
  document.addEventListener('change', function (e) {
    var root = rootFrom(e.target, 'variant-radios, variant-selects');
    if (root) updateLabels(root);
  });

  // insp-dropdown dispatches a NON-bubbling 'itemChangedData'; the capture
  // phase still reaches document, so listen there.
  document.addEventListener(
    'itemChangedData',
    function (e) {
      var root = rootFrom(e.target, 'variant-selects');
      if (root) updateLabels(root);
    },
    true
  );

  function initAll() {
    document
      .querySelectorAll('variant-radios, variant-selects')
      .forEach(updateLabels);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
